// extracted by mini-css-extract-plugin
export default {"container":"chooseItems_container__DSWkw","title":"chooseItems_title__cEglz","errorText":"chooseItems_errorText__r70g9"};